import React, { useEffect, useState } from 'react';
import mainApi from '../../redux/apis/main-api';
import './Notifications.styles.scss';
// Import Swiper React components
import { Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react';

const Notifications = () => {
	const [data, setData] = useState([]);

	useEffect(() => {
		mainApi.get('/APIS/getNotifications')
			.then((res) => {
				// Handle ResponseHelper format: {success: true, data: [...]}
				// Extract the array from the response
				const notifications = res.data?.data || res.data || [];
				setData(Array.isArray(notifications) ? notifications : []);
			})
			.catch((error) => {
				// Silently fail if endpoint doesn't exist or network error
				console.warn('Failed to load notifications:', error.message);
				setData([]);
			});
	}, []);

	return (
		<div className="notifications">
			<Swiper modules={[Pagination, Navigation]} pagination={{ clickable: true, el: '.pagingElement' }}>
				{data && Array.isArray(data) && data.length > 0 &&
					data.map((item, index) => (
						<SwiperSlide key={index}>
							<div className="notificationCard">
								<div className="title">{item.name}</div>
								<div className="heading">{item.heading}</div>
								<div className="details">
									<a href={`https://www.pocketrockets.space${item.pages_link}/${item.link}`} target="_blank">
										<button>Read more</button>
									</a>

									<div className="date">{item.date_created}</div>
								</div>
							</div>
						</SwiperSlide>
					))}
			</Swiper>
			<div className={`pagingElement`}></div>
		</div>
	);
};

export default Notifications;
